export class UserResponsibleModel {
  public usuarioId: number;
  public idsSucursal: number[] | [];
  public nombre: string;
  public apellido: string;
  public email: string;
  public estado: string;
  public rol: string;

  constructor() {
    this.usuarioId = 0;
    this.idsSucursal = [];
    this.nombre = '';
    this.apellido = '';
    this.email = '';
    this.estado = '';
    this.rol = '';
  }

  public isPresent(): boolean {
    return this.usuarioId != 0;
  }
}
